import { useDialog } from "lib/@hooks/useDialog"
import { busyWhile } from "lib/@components/busy/busy-while"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { navigate } from "lib/routes/navigate"
import { createRateCard } from "routes/rate-cards/controller/create-rate-card"
import { CreateRateCardDialog } from "./create-rate-card-dialog"

export function useCreateRateCard({ navigateOnCreate = true, regimeId } = {}) {
    const openDialog = useDialog(<CreateRateCardDialog />, { maxWidth: "sm", fullWidth: true })

    return handleCreate

    async function handleCreate() {
        const result = await openDialog({ regimeId })
        if (!result) return null
        const skillMapId = result.skillMapId?.value ?? result.skillMapId
        const parsedRate = typeof result.defaultRate === "string" ? parseFloat(result.defaultRate) : result.defaultRate
        const newCard = await busyWhile(
            () =>
                createRateCard({
                    name: result.name,
                    description: result.description || "",
                    skillMapId,
                    currency: result.currency || "GBP",
                    defaultRate: parsedRate == null || Number.isNaN(parsedRate) ? null : parsedRate,
                }),
            "Creating rate card..."
        )
        if (newCard?.id) {
            if (navigateOnCreate) {
                navigate(`/app/optimiser/rate-cards/${newCard.id}?getStarted=true`)
            }
            successSnackbar("Rate Card Created Successfully")
        }
        return newCard ? { ...newCard, name: newCard.name ?? result.name } : null
    }
}
